import register from 'ShopUiBundle/modules/app/registry';
import 'overlayscrollbars/css/OverlayScrollbars.min.css';
import './style.scss';

// tslint:disable-next-line
register('basic-scrollbar', () => import(/* webpackMode: "lazy" */'./basic-scrollbar'));
